export enum GameId {
  Solitaire = 'solitaire',
  Blocks = 'blocks',
  Blackjack = 'blackjack',
  TwentyOne = 'twentyone',
}

export function toGameId(value: string): GameId | undefined {
  if (Object.values(GameId).includes(value as GameId)) {
    return value as GameId;
  }
  return undefined;
}
